import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { mockInsightDashboardData } from './data-layer/insightDashboardMockData';
import { insightDashboardActions } from './data-store/insightDashboardSlice';
import InsightDashboard from './InsightDashboard';

/**
 * InsightDashboardContainer
 *
 * Route-level container that handles data fetching and loading states.
 * Currently uses mock data; will switch to RTK Query when API is ready.
 */
function InsightDashboardContainer() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Load mock data into Redux store
    dispatch(insightDashboardActions.setData(mockInsightDashboardData));
  }, [dispatch]);

  // For now, render directly with mock data
  // When API is ready, replace with:
  // const { requestAccessKey } = useParams<{ requestAccessKey?: string }>();
  // const { data, isLoading, isError } = useGetInsightDataQuery({ requestAccessKey });
  return <InsightDashboard data={mockInsightDashboardData} />;
}

export default InsightDashboardContainer;
